import React, { useState } from "react";
import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Button, Input } from "antd";

const RfidAssign = () => {
  //   const [loading, setLoading] = useState(true);
  //   const [printerData, setPrinterData] = useState([]);
  const [editRow, setEditRow] = useState(null); // track which row is being edited
  const [rfidValue, setRfidValue] = useState("");

  const data = [
    {
      id: 1,
      filterId: "FILT-001",
      description: "Pre-filter AHU-01",
      rfidTagId: null,
    },
    {
      id: 2,
      filterId: "FILT-002",
      description: "Fine filter AHU-01",
      rfidTagId: "RF12345",
    },
  ];

  const handleSubmit = (record) => {
    console.log("Saving RFID:", rfidValue, "for:", record);

    setEditRow(null);
    setRfidValue("");
  };

  const columns = [
    {
      title: "Filter ID",
      dataIndex: "filterId",
      key: "filterId",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "RFID Tag ID",
      dataIndex: "rfidTagId",
      key: "rfidTagId",
      render: (text) => {
        return text ? (
          <span>{text}</span>
        ) : (
          <span className="badge bg-warning text-dark text-light text-bold">
            Not Assigned
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const isEditing = editRow === record.id;

        if (isEditing) {
          return (
            <div style={{ display: "flex", gap: 6 }}>
              <Input
                placeholder="Scan / Enter RFID"
                value={rfidValue}
                onChange={(e) => setRfidValue(e.target.value)}
                style={{ width: 230 }}
              />
              <Button type="primary" onClick={() => handleSubmit(record)}>
                Submit
              </Button>
              <Button onClick={() => setEditRow(null)}>Cancel</Button>
            </div>
          );
        }

        return (
          <Button onClick={() => setEditRow(record.id)}>
            {record.rfidTagId ? "Change RFID" : "Assign RFID"}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    RFID List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Printers</h6>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {/* {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : printerData?.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={printerData}
                    rowKey="id"
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )} */}

                <Table columns={columns} dataSource={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RfidAssign;
